import { Injectable, isDevMode } from '@angular/core';
import { EMPTY } from 'rxjs';
import { tap } from 'rxjs/internal/operators/tap';
import { map } from 'rxjs/internal/operators/map';
import { UserService } from '../../user-service/user.service';
import { UserStorageService } from '../../user-storage-service/user-storage.service';
import { AudiencedDaoService } from 'src/app/dao/audience-dao-service/audience-dao.service';
import { AudienceWifiStats } from 'src/app/models/audience-models/audience-wifi-stats.model';

@Injectable({
  providedIn: 'root'
})
export class AudienceTrafficService {

  accessToken = 'TRA';

  constructor(
    private userService: UserService,
    private userStorageService: UserStorageService,
    private audienceDaoService: AudiencedDaoService
  ) { }

  public getTrafficUrl(centerInternalId) {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.audienceDaoService.getTrafficUrl(
        this.userStorageService.getContext(),
        this.userStorageService.getLang(),
        this.userStorageService.getUDID(),
        centerInternalId
      ).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => {
          return o['data']['result']['url'];
        })
      );
    }
    return EMPTY;
  }

}
